import React from "react";
import { AvailableUsersContext } from "./AvailableUsersContext.js";

export function useAvailableUsers() {
  return React.useContext(AvailableUsersContext);
}
